<script lang="ts" setup>
import type { CreateVoiceParams } from '@/stores/store'

import { ElMessage } from 'element-plus'
import { reactive } from 'vue'

import { useCharecterStore } from '@/stores/store'

const characterStore = useCharecterStore()

const VoiceLanguage = {
  cn: 0, // 中文（默认）
  en: 1, // 英文
  ja: 2, // 日语
  es: 3, // 西班牙语
  id: 4, // 印尼语
  pt: 5, // 葡萄牙语
}

const form = reactive<CreateVoiceParams>({
  speaker_id: '',
  audio: {
    bytes: '',
    format: '',
    text: '',
  },
  language: 0,
})
interface UploadFile {
  raw: File
  name: string
  // 可能还有其他属性
}
const allowedTypes = ['audio/wav', 'audio/ogg', 'audio/mpeg', 'audio/mp3', 'audio/aac', 'audio/x-m4a']

const maxFileSize = 10 * 1024 * 1024 // 10MB in bytes

function getLanguageLabel(key: string) {
  const labels: { [key: string]: string } = {
    cn: '中文',
    en: '英文',
    ja: '日语',
    es: '西班牙语',
    id: '印尼语',
    pt: '葡萄牙语',
  }
  return labels[key] || key
}

function getFileType(file: UploadFile) {
  // 'wav' | 'mp3' | 'ogg' | 'm4a' | 'aac' | 'pcm'
  const fileType = file.raw.type
  if (fileType.includes('wav')) {
    return 'wav'
  }
  else if (fileType.includes('mp3') || fileType.includes('mpeg')) {
    return 'mp3'
  }
  else if (fileType.includes('ogg')) {
    return 'ogg'
  }
  else if (fileType.includes('m4a')) {
    return 'm4a'
  }
  else if (fileType.includes('aac')) {
    return 'aac'
  }
  return ''
}

function beforeUpload(file: UploadFile) {
  const isAllowedType = allowedTypes.includes(file.raw.type)
  const isLessThan10M = file.raw.size <= maxFileSize

  if (!isAllowedType) {
    console.log(file, 'file', '>>??????????????')
    ElMessage.error('请上传 wav、mp3、ogg、m4a、aac 格式的音频文件')
  }
  if (!isLessThan10M) {
    ElMessage.error('文件大小不能超过10MB')
  }
  return isAllowedType && isLessThan10M
}

function handleFileChange(file: UploadFile) {
  console.log(file, 'change file')
  if (!beforeUpload(file)) {
    return
  }
  const reader = new FileReader()
  reader.onload = (e) => {
    const result = e.target?.result as string
    // 需要需要MIME前缀
    form.audio.bytes = result.split(',')[1]
    form.audio.format = getFileType(file)
    console.log(e, '~~~~~~~')
  }
  reader.readAsDataURL(file.raw as Blob)
}

async function submitForm() {
  if (!form.speaker_id || !form.audio.bytes || !form.audio.text) {
    ElMessage.error('请填写音色ID并上传音频文件')
    return
  }
  // 这里可以添加提交表单的逻辑
  console.log('提交的表单数据:', form)
  const res = await characterStore.createVoice(form)
  if (res) {
    ElMessage.error(res)
  }
  else {
    ElMessage.success('音色创建成功')
  }
}
</script>

<template>
  <div>
    <h1 class="title">
      创建火山tts音色
    </h1>
    <el-form :model="form" label-width="180px" class="create-voice-form">
      <el-form-item label="音色ID(请前往火山控制台查看)">
        <el-input v-model="form.speaker_id" placeholder="请输入音色ID" />
      </el-form-item>
      <el-form-item label="音频文件">
        <el-upload
          class="upload-demo"
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :limit="1"
          :before-upload="beforeUpload"
          accept=".wav,.mp3,.ogg,.m4a,.aac"
        >
          <el-button size="small" type="primary">
            选择文件
          </el-button>
          <template #tip>
            <div class="el-upload__tip">
              请选择 wav、mp3、ogg、m4a、aac格式的音频文件
            </div>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item label="语音对应的文字（必须精准）">
        <el-input v-model="form.audio.text" placeholder="请输入语音对应的文字" />
      </el-form-item>

      <el-form-item label="语言">
        <el-select v-model="form.language" placeholder="请选择语言">
          <el-option
            v-for="(value, key) in VoiceLanguage"
            :key="value"
            :label="getLanguageLabel(key)"
            :value="value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          创建音色
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped>
.create-voice-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.title {
    text-align: center;
    color: #409EFF;
    margin-bottom: 30px;
}

.create-voice-form {
    background-color: #f5f7fa;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-form-item {
    margin-bottom: 25px;
}

.el-form-item__label {
    font-size: 16px;
    font-weight: 600;
}

.el-upload__tip {
    line-height: 1.5;
    color: #606266;
    font-size: 14px;
}
</style>
